import { render } from "./CheckoutComponent.vue?vue&type=template&id=20d64165"
import script from "./CheckoutComponent.vue?vue&type=script&lang=js"
export * from "./CheckoutComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/checkout/checkout/CheckoutComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20d64165"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20d64165', __exports__)) {
    api.reload('20d64165', __exports__)
  }
  
  module.hot.accept("./CheckoutComponent.vue?vue&type=template&id=20d64165", () => {
    api.rerender('20d64165', render)
  })

}


export default __exports__